import { useEffect, useState } from "react";

import { useCurrentAccount } from "@/hooks/useCurrentAccount";
import { Option } from "@/@types/generics/Option";
import { Department } from "@/@types/sintegrada/Department";
import { getDepartments } from "@/services/sintegrada/departments/getDepartments";

import { SelectComponent, SelectComponentProps } from "@/components/SelectComponent";

import { Props as ReactSelectProps } from "react-select";

type Props = SelectComponentProps & ReactSelectProps & {
	autoSelectFirst?: boolean;
};

type InternalDepartmentOptions = Option<Department>[];

type ActionChange = {
	action: "select-option";
	option: Option<Department>;
};

export function InternalDepartmentSelect({ autoSelectFirst = false, onChange, ...rest }: Props) {
	const { uf, ibgeCode, cnes } = useCurrentAccount();

	const [options, setOptions] = useState<InternalDepartmentOptions>([]);

	async function fetchData() {
		const data = await getDepartments({
			uf,
			ibgeCode,
			cnes,
		});

		const internalDepartmentNames = ["Internamento", "Sala Vermelha", "Observação"];
		const internalDepartments = data.filter((internalDepartment) =>
			internalDepartmentNames.includes(internalDepartment.name)
		);

		const transformedData = internalDepartments.map((internalDepartment) => ({
			value: internalDepartment,
			label: internalDepartment.name,
		}));

		setOptions(transformedData);
		
		const [firstOption] = transformedData;
		
		if (autoSelectFirst && onChange) {
			const actionChange: ActionChange = { action: "select-option", option: firstOption };

			onChange(firstOption, actionChange);
		}
	}

	useEffect(() => {
		fetchData();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<SelectComponent
			placeholder="Selecione..."
			options={options}
			onChange={onChange}
			{...rest}
		/>
	);
}
